import { BaseClass } from '../base-class';
import { BaseRepository } from '@interfaces/base-repository';
import { User } from '../user/user';
import { Client } from '../client';

export class Vehicle extends BaseClass implements BaseRepository {
  numberplate: string;
  client: Client;
  user: User;
  comment?: string;
  activeSurvey: boolean;
  mileage: number;
  name: string;
  url: string;
  isDeleted: boolean;

  dateIn: Date;
  dateOut: Date;
  mileageIn: number;
  mileageOut: number;
  internalId: number;

  merchandiseLicense: string;
  passengerLicense: string;
  tollBadgeNumber: string;
  fuelCardNumber: string;
  fuelCardExpiryDate: Date;

  constructor();
  constructor(
    numberplate: String,
    user: User,
    client: Client,
    comment: string,
    mileage?: number,
    activeSurvey?: boolean,
    name?: string,
    url?: string,
    dateIn?: Date,
    dateOut?: Date,
    mileageIn?: number,
    mileageOut?: number,
    internalId?: number,
    merchandiseLicense?: string,
    passengerLicense?: string,
    tollBadgeNumber?: string,
    fuelCardNumber?: string,
    fuelCardExpiryDate?: Date,
  );
  constructor(
    numberplate?: string,
    user?: User,
    client?: Client,
    comment?: string,
    mileage?: number,
    activeSurvey?: boolean,
    name?: string,
    url?: string,
    dateIn?: Date,
    dateOut?: Date,
    mileageIn?: number,
    mileageOut?: number,
    internalId?: number,
    merchandiseLicense?: string,
    passengerLicense?: string,
    tollBadgeNumber?: string,
    fuelCardNumber?: string,
    fuelCardExpiryDate?: Date,
  ) {
    super();

    this.numberplate = this.trim(numberplate);
    this.user = user;
    this.client = client;
    this.comment = comment;
    this.mileage = mileage;
    this.activeSurvey = activeSurvey;
    this.name = name;
    this.url = url;
    this.dateIn = dateIn;
    this.dateOut = dateOut;
    this.mileageIn = mileageIn;
    this.mileageOut = mileageOut;
    this.internalId = internalId;
    this.merchandiseLicense = merchandiseLicense;
    this.passengerLicense = passengerLicense;
    this.tollBadgeNumber = tollBadgeNumber;
    this.fuelCardNumber = fuelCardNumber;
    this.fuelCardExpiryDate = fuelCardExpiryDate;
  }

  static fromObject(object: Vehicle): Vehicle {
    return Object.assign(new Vehicle(), {
      ...object,
      client: object.client ? Client.fromObject(object.client) : null,
      user: object.user ? User.fromObject(object.user) : null,
    });
  }

  get display(): string {
    return `${this.numberplate}`;
  }

  doesInclude(value: string): boolean {
    return this.some([this.numberplate], value);
  }
}
